export {default} from 'views/Companies/Companies'


// WEBPACK FOOTER //
// ./src/views/Administration/Companies.jsx